var arrayMap = require('./_arrayMap');

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;



//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/lodash/_baseValues.js
// module id = 532
// module chunks = 0